import {
  FETCH_DEPARTMENTS,
  ERROR_FETCH_DEPARTMENTS,
  SEARCH_DEPARTMENTS,
} from '../actions/types';

const initialState = {
  data: [],
  pageNumber: 1,
  pageSize: 0,
  totalElment: 0,
  total_pages: 0,
  loading: true,
};
export default function (state = initialState, action) {
  const { type, payload } = action;
  // console.log('state', payload);
  switch (type) {
    case FETCH_DEPARTMENTS:
    case SEARCH_DEPARTMENTS:
      return {
        ...state,
        data: payload.data,
        pageNumber: payload.pageNumber,
        pageSize: payload.pageSize,
        totalElment: payload.totalElment,
        total_pages: payload.total_pages,
        loading: false,
      };
    case ERROR_FETCH_DEPARTMENTS:
      return { ...state };
    default:
      return state;
  }
}
